<section class="page-hero certificates-hero">
    <div class="container">
        <span class="eyebrow"><i></i> Admin Certificates</span>
        <h1>Manage certificates and PDF documents.</h1>
        <p>Upload PDF documents and control which certificates appear on the public website.</p>
    </div>
</section>

<section class="section">
    <div class="container">

        <div style="margin-bottom:24px">
            <a class="learn" routerLink="/admin/dashboard">← Back to dashboard</a>
        </div>

        <div class="contact-grid">

            <main class="quote-panel">
                <h2 style="font-size:32px;margin-top:0">
                    {{ model.id === 0 ? 'New Certificate' : 'Edit Certificate' }}
                </h2>

                <div class="form-grid">

                    <div class="field">
                        <label>Title</label>
                        <input [(ngModel)]="model.title" name="title" placeholder="ISO 9001 Quality Management">
                    </div>

                    <div class="field">
                        <label>Category</label>
                        <select [(ngModel)]="model.category" name="category">
                            <option value="">Select category</option>
                            <option>Quality</option>
                            <option>HSE</option>
                            <option>Supplier</option>
                            <option>Testing</option>
                            <option>Manufacturing</option>
                            <option>Logistics</option>
                        </select>
                    </div>

                    <div class="field">
                        <label>Year</label>
                        <input [(ngModel)]="model.year" name="year" placeholder="2026">
                    </div>

                    <div class="field">
                        <label>Sort</label>
                        <input type="number" [(ngModel)]="model.sort" name="sort">
                    </div>

                    <div class="field">
                        <label>Status</label>
                        <select [(ngModel)]="model.status" name="status">
                            <option [ngValue]="true">Active</option>
                            <option [ngValue]="false">Hidden</option>
                        </select>
                    </div>

                    <div class="field full">
                        <label>Description</label>
                        <textarea [(ngModel)]="model.description" name="description" placeholder="Certificate description"></textarea>
                    </div>

                    <div class="field full">
                        <label>PDF File</label>
                        <input type="file" accept=".pdf" (change)="onFileChange($event)">
                    </div>

                    <div class="field full" *ngIf="successMessage">
                        <div class="alert success">{{ successMessage }}</div>
                    </div>

                    <div class="field full" *ngIf="errorMessage">
                        <div class="alert error">{{ errorMessage }}</div>
                    </div>

                    <div class="field full" style="display:flex;gap:10px;flex-direction:row">
                        <button class="btn btn-primary" type="button" (click)="saveCertificate()" [disabled]="saving">
                            {{ saving ? 'Saving...' : 'Save Certificate' }}
                        </button>

                        <button class="btn btn-ghost" type="button" (click)="newCertificate()">
                            Clear
                        </button>
                    </div>

                </div>
            </main>

            <aside>
                <span class="section-kicker">Certificates</span>
                <h2 style="font-size:34px">Document list.</h2>

                <div *ngIf="loading">Loading certificates...</div>

                <div class="office-card premium-office" *ngFor="let c of certificates">
                    <h3>{{ c.title }}</h3>
                    <p>{{ c.category }} / Updated {{ c.year }}</p>
                    <span>{{ c.status ? 'Active' : 'Hidden' }}</span>

                    <div style="display:flex;gap:8px;margin-top:14px;flex-wrap:wrap">
                        <a class="btn btn-ghost"
                           [href]="adminApi.getFileUrl(c.filePath)"
                           target="_blank">
                            Open PDF
                        </a>

                        <button class="btn btn-ghost" type="button" (click)="editCertificate(c)">
                            Edit
                        </button>

                        <button class="btn btn-dark" type="button" (click)="deleteCertificate(c.id)">
                            Delete
                        </button>
                    </div>
                </div>
            </aside>

        </div>

    </div>
</section>